import React, { Component, PropTypes } from 'react';
import DownArrow from '../shared/DownArrow';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import WeatherAlertIcon from './WeatherAlertIcon';
import ComponentTitle from 'components/shared/ComponentTitle';
import Timestamp from '../Timestamp';
import { formatWsiDate } from '../../utils/DateUtils';
import { getWeatherCategoryFromCondition } from '../../utils/WeatherUtils';
import { get, find, findIndex, assign } from 'lodash';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

class DedicatedWeatherAlert extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    allowedAlerts: PropTypes.array,
    timestampOptions: PropTypes.shape({
      showElapsedTime: PropTypes.bool,
      displayShortDateTime: PropTypes.bool
    }),
    titleType: PropTypes.string
  }

  static defaultProps = {
    allowedAlerts: [],
    titleType: TITLE_TYPE.MODULE_TITLE
  }
  
  _filterAlerts(alerts, allowedAlerts) {
    const filteredAlerts = [];

    alerts.forEach(alert => {
      const type = alert.name.toLowerCase();
      const filteredAlert = allowedAlerts.find(allowedAlr => (allowedAlr.type.toLowerCase() === type));
      
      if (filteredAlert) {
        filteredAlerts.push(assign(alert, {backgroundColor: filteredAlert.backgroundColor}));
      }
    });
    
    return filteredAlerts;
  }

  _buildWeatherAlertData(alerts, props) {
    const alertData = [];

    alerts.forEach(alert => {
      const {
        id: categoryId,
        name: categoryName,
        weather: weatherObj,
        weathers: weatherArr,
        backgroundColor
      } = alert;

      const weathers = weatherArr || (weatherObj ? [weatherObj] : []);

      weathers.forEach(weather => {
        const {
          name: alertType,
          county: countyObj,
          countys: countyArr
        } = weather;
      
        const counties = countyArr || (countyObj ? [countyObj] : []);
        
        counties.forEach(county => {
          const {
            id: countyId,
            name: countyName,
            text: alertText,
            startdate: startDate
          } = county;

          const alertItem = {
            type: alertType,
            text: alertText,
            startDate,
            backgroundColor,
            ...props
          };

          /** group counties by countyId */
          const countyIndex = findIndex(alertData, (item) => item.countyId === countyId);

          if (countyIndex !== -1) {
            /** group categories by categoryId */
            const cateIndex = findIndex(alertData[countyIndex].categories, (item) => item.categoryId === categoryId);

            if (cateIndex !== -1) {
              alertData[countyIndex].categories[cateIndex].alerts.push(alertItem);
            } else {
              alertData[countyIndex].categories.push({
                categoryId,
                categoryName,
                alerts: [alertItem]
              });
            }
          } else {
            alertData.push({
              countyId,
              countyName,
              categories: [{
                categoryId,
                categoryName,
                alerts: [alertItem]
              }]
            });
          }
        });
      });
    });

    return alertData;
  }

  render() {
    const {
      FRN_rawResponses,
      title = '',
      allowedAlerts,
      timestampOptions,
      titleType
    } = this.props;

    const features = get(FRN_rawResponses[0], 'data.features', []);
    const weatherAlerts = find(features, (f) => f.type === 'weatheralerts');

    const {
      alert: alertObj,
      alerts: alertArr
    } = weatherAlerts || {};

    const alerts = alertArr || (alertObj ? [alertObj] : []);

    const filteredAlerts = this._filterAlerts(alerts, allowedAlerts);
    const alertData = filteredAlerts.length > 0 ? this._buildWeatherAlertData(filteredAlerts, { timestampOptions }) : [];
 
    return (
      <div className="DedicatedWeatherAlert">
        <div className="DedicatedWeatherAlert-header">
          <ComponentTitle showArrow={false} title={title} titleType={titleType}/>
          <h2 className="DedicatedWeatherAlert-title"><strong>All Counties</strong></h2>
        </div>
        {
          alertData.map((item, key) => 
          <CountyAlertItem 
            {...item}
            key={key}
          />
          )
        }
      </div>
    );
  }
}

class CountyAlertItem extends Component {
  static propTypes = {
    countyName: PropTypes.string,
    categories: PropTypes.array
  }

  state = {
    expendCounty: false
  }

  _expendCounty() {
    this.setState({
      expendCounty: !this.state.expendCounty
    });
  }

  render() {
    const { expendCounty } = this.state;
    const { 
      countyName,
      categories = []
    } = this.props;

    const numberOfAlert = categories.reduce((sum, category) =>  (sum + category.alerts.length), 0);

    const weatherAlertCategories = categories.map((category, key) => (
      <WeatherAlertCategory
        {...category}
        key={key}
      />
    ));

    return (
      <div>
        <div className="County" onClick={() => this._expendCounty()}>
          <h2 className="County-name">{countyName} <span>( {numberOfAlert} Alerts )</span></h2>
          <DownArrow
            arrowState={expendCounty ? 'cross' : 'arrow'}
          />
        </div>

        <ReactCSSTransitionGroup transitionName="weather-alert" transitionEnterTimeout={200} transitionLeaveTimeout={200}>
          {expendCounty ?
          <div>{weatherAlertCategories}</div> : null}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

class WeatherAlertCategory extends Component {
  static propTypes = {
    categoryName: PropTypes.string,
    alerts: PropTypes.array
  }

  state = {
    showAlerts: false,
  }

  _showAlerts() {
    this.setState({
      showAlerts: !this.state.showAlerts
    });
  }

  render() {
    const { showAlerts } = this.state;
    const { categoryName, alerts } = this.props;

    const weatherAlertItems = alerts.map((alertItem, key) => (
      <WeatherAlertItem 
        key={key}
        {...alertItem}
      />
    ));

    return (

      <div className="Alerts">
        <div className="Alerts-category" onClick={() => this._showAlerts()}>
          <h2>{categoryName.toLowerCase()}</h2>
          <DownArrow
            arrowState={showAlerts ? 'cross' : 'arrow'}
          />
        </div>

        <ReactCSSTransitionGroup transitionName="weather-alert" transitionEnterTimeout={200} transitionLeaveTimeout={200}>
          {showAlerts ?
          <div>{weatherAlertItems}</div> : null}
        </ReactCSSTransitionGroup>

      </div>
    );
  }
}

class WeatherAlertItem extends Component {
  static propTypes = {
    type: PropTypes.string,
    text: PropTypes.string,
    startDate: PropTypes.string,
    backgroundColor: PropTypes.string,
    timestampOptions: PropTypes.shape({
      showElapsedTime: PropTypes.bool,
      displayShortDateTime: PropTypes.bool
    })
  }

  state = {
    showAlertDescription: true,
  }

  _showAlertDescription() {
    this.setState({
      showAlertDescription: !this.state.showAlertDescription
    });
  }

  render() {
    const { showAlertDescription } = this.state;
    const { 
      type,
      text,
      startDate,
      backgroundColor,
      timestampOptions = {}
     } = this.props;

    const formattedBulletin = text.toLowerCase().replace(/(\/.*(\d{6}t\d{4}z(\.|-)?){1,3}.*\/\n)|((\D{0,3}\d{3,}(-|>))+(\d{3,6})?\n)|(&&(.*\n)+\$\$)/g, '');
    const formattedDate = formatWsiDate(startDate);
    const category = getWeatherCategoryFromCondition(type);

    return (
      <div className="Alert">
        <div className="Alert-content" onClick={() => this._showAlertDescription()}>
          <WeatherAlertIcon 
            iconType={category}
            backgroundColor={backgroundColor}  
          />
          <div className="Alert-summary">
            <h2>{type}</h2>
            <Timestamp publishDate={formattedDate} {...timestampOptions}/>
          </div>
          <DownArrow
            arrowState={showAlertDescription ? 'cross' : 'arrow'}
          />
        </div>
        <ReactCSSTransitionGroup transitionName="weather-alert" transitionEnterTimeout={200} transitionLeaveTimeout={200}>
        {showAlertDescription ? 
          <div className="Alert-description" 
          dangerouslySetInnerHTML={{__html: formattedBulletin.replace(/\n/g, '<br />') }}
          /> : null
        }
        </ReactCSSTransitionGroup>
      </div>
    );  
  }
}

export default DedicatedWeatherAlert;



// WEBPACK FOOTER //
// ./app/components/weather/DedicatedWeatherAlert.js